import { render } from "./SongEditForm.vue?vue&type=template&id=088d70f6&scoped=true"
import script from "./SongEditForm.vue?vue&type=script&lang=js"
export * from "./SongEditForm.vue?vue&type=script&lang=js"

import "./SongEditForm.vue?vue&type=style&index=0&id=088d70f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-088d70f6"

export default script